import { render, staticRenderFns } from "./CareAssistance.vue?vue&type=template&id=b7aa7e8e"
import script from "./CareAssistance.vue?vue&type=script&lang=js"
export * from "./CareAssistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports